export enum CareCondition {
  WELL_GROOMED = 'well_groomed',
  UNGROOMED = 'ungroomed',
  SEBORRHOEIC = 'seborrhoeic',
  ALOPECIC = 'alopecic',
  PARASITIZED = 'parasitized',
  NONE = 'none',
}

export enum NutritionCondition {
  ADIPOS = 'adipos',
  OVERCONDITIONED = 'overconditioned',
  NORMAL = 'normal',
  UNDERCONDITIONED = 'underconditioned',
  CACHECTIC = 'cachectic',
}

export enum TemperamentCondition {
  DOCILE = 'docile',
  AGGRESSIVE = 'aggressive',
  FEARFUL = 'fearful',
  INSECURE = 'insecure',
  NEOPHOBIC = 'neophobic',
  SOCIAL = 'social',
  HUMAN_FOCUSED = 'human_focused',
  RESERVED = 'reserved',
}

export const CARE_OPTIONS = [
  { value: CareCondition.WELL_GROOMED, label: 'bcs.care.wellGroomed', description: 'bcs.care.wellGroomed.desc' },
  { value: CareCondition.UNGROOMED, label: 'bcs.care.ungroomed', description: 'bcs.care.ungroomed.desc' },
  { value: CareCondition.SEBORRHOEIC, label: 'bcs.care.seborrhoeic', description: 'bcs.care.seborrhoeic.desc' },
  { value: CareCondition.ALOPECIC, label: 'bcs.care.alopecic', description: 'bcs.care.alopecic.desc' },
  { value: CareCondition.PARASITIZED, label: 'bcs.care.parasitized', description: 'bcs.care.parasitized.desc' },
  { value: CareCondition.NONE, label: 'bcs.care.none', description: 'bcs.care.none.desc' },
];

export const NUTRITION_OPTIONS = [
  { value: NutritionCondition.ADIPOS, label: 'bcs.nutrition.adipos', description: 'bcs.nutrition.adipos.desc' },
  { value: NutritionCondition.OVERCONDITIONED, label: 'bcs.nutrition.overconditioned', description: 'bcs.nutrition.overconditioned.desc' },
  { value: NutritionCondition.NORMAL, label: 'bcs.nutrition.normal', description: 'bcs.nutrition.normal.desc' },
  { value: NutritionCondition.UNDERCONDITIONED, label: 'bcs.nutrition.underconditioned', description: 'bcs.nutrition.underconditioned.desc' },
  { value: NutritionCondition.CACHECTIC, label: 'bcs.nutrition.cachectic', description: 'bcs.nutrition.cachectic.desc' },
];

export const TEMPERAMENT_OPTIONS = [
  { value: TemperamentCondition.DOCILE, label: 'bcs.temper.docile', description: 'bcs.temper.docile.desc' },
  { value: TemperamentCondition.AGGRESSIVE, label: 'bcs.temper.aggressive', description: 'bcs.temper.aggressive.desc' },
  { value: TemperamentCondition.FEARFUL, label: 'bcs.temper.fearful', description: 'bcs.temper.fearful.desc' },
  { value: TemperamentCondition.INSECURE, label: 'bcs.temper.insecure', description: 'bcs.temper.insecure.desc' },
  { value: TemperamentCondition.NEOPHOBIC, label: 'bcs.temper.neophobic', description: 'bcs.temper.neophobic.desc' },
  { value: TemperamentCondition.SOCIAL, label: 'bcs.temper.social', description: 'bcs.temper.social.desc' },
  { value: TemperamentCondition.HUMAN_FOCUSED, label: 'bcs.temper.humanFocused', description: 'bcs.temper.humanFocused.desc' },
  { value: TemperamentCondition.RESERVED, label: 'bcs.temper.reserved', description: 'bcs.temper.reserved.desc' },
];
